var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useMemo, useState } from "react";
import { PageHeaderStyles } from "@/components/styles/PageHeaderStyles";
import { Checkbox, TextField } from "@mui/material";
import { SaveButton, SimpleForm, useNotify, useRefresh } from "react-admin";
import { useTranslation } from "react-i18next";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { useMutation } from "@apollo/client";
import { CREATE_ROLE } from "@/queries/CreateRole";
import { DataGrid } from "@mui/x-data-grid";
import { IPermissions } from "@/types/keycloak";
import { getEnumValues } from "./EditRole";
export var CreateRole = function (_a) {
    var close = _a.close, permissions = _a.permissions;
    var t = useTranslation().t;
    var tenantId = useTenantStore()[0];
    var _b = useState([]), rolePermissions = _b[0], setRolePermissions = _b[1];
    var _c = useState({
        access: {
            manage: true,
            manageMembers: true,
            manageMembership: true,
            view: true,
            viewMembers: true,
        },
        permissions: [],
    }), role = _c[0], setRole = _c[1];
    var createRole = useMutation(CREATE_ROLE)[0]; //<CreateRoleMutationVariables>(CREATE_ROLE)
    var notify = useNotify();
    var refresh = useRefresh();
    var validPermissions = getEnumValues(IPermissions);
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, errors, data, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    console.log("creating role");
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, createRole({
                            variables: {
                                tenantId: tenantId,
                                role: __assign(__assign({}, role), { permissions: rolePermissions }),
                            },
                        })];
                case 2:
                    _a = _b.sent(), errors = _a.errors, data = _a.data;
                    console.log("data: ", data);
                    if (errors) {
                        notify(t("usersAndRolesScreen.roles.errors.createError"), { type: "error" });
                        console.log("Error creating user: ".concat(errors));
                    }
                    else {
                        notify(t("usersAndRolesScreen.roles.errors.createSuccess"), { type: "success" });
                        refresh();
                    }
                    close === null || close === void 0 ? void 0 : close();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    notify(t("usersAndRolesScreen.voters.roles.createError"), { type: "error" });
                    console.log("Error creating role: ".concat(error_1));
                    close === null || close === void 0 ? void 0 : close();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, name, value;
        var _b;
        return __generator(this, function (_c) {
            _a = e.target, name = _a.name, value = _a.value;
            setRole(__assign(__assign({}, role), (_b = {}, _b[name] = value, _b)));
            return [2 /*return*/];
        });
    }); };
    var rows = useMemo(function () {
        return (permissions || [])
            .filter(function (permission) {
            return permission.name && validPermissions.includes(permission.name);
        })
            .map(function (permission) {
            return __assign(__assign({}, permission), { id: permission.id || "", name: permission.name, active: (!!permission.name && rolePermissions.includes(permission.name)) ||
                    false, displayName: permission.name &&
                    t("usersAndRolesScreen.permissions.".concat(permission.name)) });
        });
    }, [rolePermissions]);
    var editRolePermission = function (props) { return function () { return __awaiter(void 0, void 0, void 0, function () {
        var exsitPermmistion, filteredPermissions;
        return __generator(this, function (_a) {
            exsitPermmistion = rolePermissions.find(function (p) { return p === props.row.name; });
            if (exsitPermmistion) {
                filteredPermissions = rolePermissions.filter(function (p) { return p !== props.row.name; });
                setRolePermissions(filteredPermissions);
            }
            else {
                setRolePermissions(function (prev) { return __spreadArray(__spreadArray([], prev, true), [props.row.name], false); });
            }
            return [2 /*return*/];
        });
    }); }; };
    var columns = [
        {
            field: "displayName",
            headerName: "Permission",
            width: 350,
            editable: false,
        },
        {
            field: "active",
            headerName: "Active",
            width: 70,
            editable: false,
            renderCell: function (props) { return (_jsx(Checkbox, { checked: props.value, onClick: editRolePermission(props) })); },
        },
    ];
    return (_jsx(PageHeaderStyles.Wrapper, { children: _jsxs(SimpleForm, { toolbar: _jsx(SaveButton, { alwaysEnable: true }), onSubmit: onSubmit, sanitizeEmptyValues: true, children: [_jsx(PageHeaderStyles.Title, { children: t("usersAndRolesScreen.roles.create.title") }), _jsx(PageHeaderStyles.SubTitle, { children: t("usersAndRolesScreen.roles.create.subtitle") }), _jsx(TextField, { variant: "outlined", label: String(t("usersAndRolesScreen.roles.fields.name")), value: role.name || "", name: "name", onChange: handleChange }), _jsx(DataGrid, { rows: rows, columns: columns, initialState: {
                        pagination: {
                            paginationModel: {
                                pageSize: 10,
                            },
                        },
                    }, pageSizeOptions: [10, 20, 50, 100] })] }) }));
};
